import React from 'react';
import { Link } from 'react-router-dom';
import logoLeft from '../assets/logo-fenerbahce-arma.webp'; // SVG'deki maske telefonda pikselli işleniyordu; aynı tuvalden üretilmiş saydam WebP

const JoinCta = () => {
  return (
    <section className="relative py-10 overflow-hidden">
      {/* Fenerbahçe Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#1F3A65] via-[#2a4a7a] to-[#1F3A65]"></div>
      <div className="absolute inset-0 bg-gradient-to-br from-[#fdd023]/10 via-transparent to-[#fdd023]/20"></div>

      {/* Subtle Background Elements */}
      <div className="absolute top-0 right-0 w-32 h-32 bg-[#fdd023]/10 rounded-full translate-x-16 -translate-y-16"></div>
      <div className="absolute bottom-0 left-0 w-24 h-24 bg-[#1F3A65]/10 rounded-full -translate-x-12 translate-y-12"></div>
      <div className="absolute top-1/2 left-1/2 w-48 h-48 -translate-x-1/2 -translate-y-1/2">
        <img
          src={logoLeft}
          alt="Fenerbahçe Arma"
          className="w-full h-full object-contain opacity-5"
        />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-7">
          <h2 className="text-2xl sm:text-3xl font-black text-white mb-3">
            SEN DE BU <span className="text-[#fdd023]">AİLENİN PARÇASI OL</span>
          </h2>
          <p className="text-white/80 max-w-2xl mx-auto text-sm sm:text-base leading-relaxed">
            Fenerbahçe sevgisini İskoçya'da yalnızca yaşatmıyor, birlik ve dayanışmayla geleceğe
            taşıyoruz. İskoçya Fenerbahçeliler Derneği çatısı altında, sarı-lacivert renklere gönül
            verenleri güçlü bir aidiyet ve ortak bir tutku etrafında buluşturuyoruz.
          </p>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-2 gap-4 max-w-3xl mx-auto">
          {/* Üyelik Kartı */}
          <div className="group bg-gradient-to-br from-[#fdd023]/20 to-[#ffe600]/10 backdrop-blur-sm rounded-xl p-5 border border-[#fdd023]/30 hover:border-[#fdd023]/50 transition-all duration-300 transform hover:-translate-y-1 flex flex-col">
            <div className="text-center flex flex-col h-full">
              <div className="w-10 h-10 bg-[#fdd023] rounded-full flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform duration-300">
                <span className="text-[#1F3A65] font-black text-sm">FB</span>
              </div>
              <h3 className="text-base font-bold text-white mb-2">ÜYE OL</h3>
              <p className="text-white/70 text-xs sm:text-sm leading-relaxed mb-4 flex-grow">
                Sarı-lacivert topluluğumuzdaki yerinizi alın, dernek faaliyetlerimize katılın ve
                Fenerbahçe ruhunu İskoçya'da hep birlikte büyütelim.
              </p>
              <Link
                to="/membership"
                className="inline-block w-full bg-[#fdd023] text-[#1F3A65] py-2.5 px-3 rounded-lg font-bold text-xs sm:text-sm hover:bg-[#ffe600] transition-colors duration-300"
              >
                ÜYELİK BAŞVURUSU
              </Link>
            </div>
          </div>

          {/* Destek Kartı */}
          <div className="group bg-gradient-to-br from-[#1F3A65]/20 to-[#2a4a7a]/10 backdrop-blur-sm rounded-xl p-5 border border-[#1F3A65]/30 hover:border-[#1F3A65]/50 transition-all duration-300 transform hover:-translate-y-1 flex flex-col">
            <div className="text-center flex flex-col h-full">
              <div className="w-10 h-10 bg-[#1F3A65] rounded-full flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform duration-300">
                <span className="text-[#fdd023] font-black text-sm">♥</span>
              </div>
              <h3 className="text-base font-bold text-white mb-2">DESTEK OL</h3>
              <p className="text-white/70 text-xs sm:text-sm leading-relaxed mb-4 flex-grow">
                Derneğimizin projelerine ve faaliyetlerine katkı sağlayarak bu güçlü birlikteliğin
                gelişimine destek olabilirsiniz.
              </p>
              <Link
                to="/contact"
                className="inline-block w-full bg-[#1F3A65] text-[#fdd023] py-2.5 px-3 rounded-lg font-bold text-xs sm:text-sm hover:bg-[#2a4a7a] transition-colors duration-300"
              >
                BİZE ULAŞIN
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinCta;
